
/* eslint-disable max-len */
import React from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { convertEpochToDateFormat } from '../../../../CommonMethods/convertEpochToDateFormat'

const TableBodyPatient=({tableData,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    fromPatientTab,
    lastIndex,
    setConfirmationState,
    setTextAreaMsg})=>{
    const navigate=useNavigate()
    const auth=useSelector(state=>state?.auth)
    const {userType}=auth
    const dispatch=useDispatch()
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams,setSearchParams]=useSearchParams({})
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
  
    const date=convertEpochToDateFormat(tableData?.created_at,dateformat)
    return(
        <>
            <AnimatedList
                id={tableData.patient_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                //cursorpointer
                // handleClick={(e)=>{
                //     if (e.target.classList.contains('prevent-click')) {
                //         return;
                //     } else {
                //         fromPatientTab==='true'?navigate(`/manage-patients/provider-list/${tableData._id}/${tableData.patient_id}`,{state:{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),'user_id':tableData?.patient_id,'id':tableData?._id}}):navigate(`/manage-dashboard/provider-list/${tableData._id}/${tableData.patient_id}`,{state:{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),'user_id':tableData?.patient_id,'id':tableData?._id}})
                //     }
                // }}
                child={
                    <>

                        <td className=" px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{convertEpochToDateFormat(tableData?.timestamp,dateformat)}</td>
                        <td className=" px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.user_id===undefined||tableData?.user_id==="-"||tableData?.user_id===""||tableData?.user_id==='SUPERADMIN')?'-':tableData?.user_id}</td>
                        <td className=" px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.first_name} {tableData?.last_name}</td>
                        <td className=" px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_id}</td>
                        <td className=" px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{[tableData?.patient_first_name, tableData?.patient_middle_name, tableData?.patient_last_name].filter(v => v && v !== '-').join(' ')}</td>
                        <td className=" px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.status===undefined||tableData?.status==="-"||tableData?.status==="")?'-':tableData?.status}</td>
                        <td className=" px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {(tableData?.end_time===undefined||tableData?.end_time==="-"||tableData?.end_time==="")?'-':tableData?.end_time?.replace(/^\(|\)$/g, '')}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-justify font-normal text-[#031624]">
                            {tableData?.description === "" || tableData?.description === undefined
                                ? "-"
                                : tableData?.description.length > 87
                                    ? `${tableData.description.slice(0, 87)}...`
                                    : tableData.description}
                        </td>
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBodyPatient
